// UI dil kodları, profil API değerleri ve menü etiketlerinin ortak kaynağı.
export const UI_LANGUAGES = [
  { locale: "tr", code: "Turkish", label: "TR", fullLabel: "Türkçe", flag: "🇹🇷" },
  { locale: "en", code: "English", label: "EN", fullLabel: "English", flag: "🇺🇸" },
  { locale: "de", code: "German", label: "DE", fullLabel: "Deutsch", flag: "🇩🇪" },
  { locale: "ar", code: "Arabic", label: "AR", fullLabel: "العربية", flag: "🇸🇦" },
  { locale: "es", code: "Spanish", label: "ES", fullLabel: "Español", flag: "🇪🇸" },
  { locale: "fr", code: "French", label: "FR", fullLabel: "Français", flag: "🇫🇷" },
  { locale: "it", code: "Italian", label: "IT", fullLabel: "Italiano", flag: "🇮🇹" },
] as const;

export type UILocale = (typeof UI_LANGUAGES)[number]["locale"];
export type UILanguageName = (typeof UI_LANGUAGES)[number]["code"];

export const getUILocale = (value?: string): UILocale => {
  const normalized = value?.trim().toLowerCase().replace(/_/g, "-");
  return UI_LANGUAGES.find(
    ({ locale, code }) => locale === normalized?.split("-")[0] || code.toLowerCase() === normalized,
  )?.locale ?? "en";
};

export const getUILanguageName = (value?: string): UILanguageName =>
  UI_LANGUAGES.find(({ locale }) => locale === getUILocale(value))!.code;

// Açık URL tercihi, kalıcı tercihin ve profilin üzerine uygulanır.
export const getLanguageFromURL = (): UILanguageName | undefined => {
  if (typeof window === "undefined") return undefined;
  const language = new URLSearchParams(window.location.search).get("lang");
  return language ? getUILanguageName(language) : undefined;
};
